import React from 'react';
import { RendererProps } from '@tunz/data-tables';
import useReferential from '../../useReferential';
import { Product, PRODUCTS } from '../../Referentials/Referentials';

const ProductFormatter: React.FC<RendererProps> = ({ value }: RendererProps) => {
	const [loading, products] = useReferential<Product>(PRODUCTS);
	if (loading) {
		return <div>{value}</div>;
	}
	const numericValue = Number.parseInt(value, 10);
	const product = products.find((b) => b.id === numericValue);
	return <div>{product ? product.label : value}</div>;
};
export default ProductFormatter;
